export default __webpack_public_path__ + "static/media/php.88405124.svg";